import {
    BOOKMARK_BEGIN,
    BOOKMARK_SUCCESS,
    BOOKMARK_FAILURE,
    CLEAR_BOOKMARK,

    BOOKMARK_PREVIEW_BEGIN,
    BOOKMARK_PREVIEW_SUCCESS,
    BOOKMARK_PREVIEW_FAILURE,
    CLEAR_BOOKMARK_PREVIEW,

    BOOKMARK_FILTERS_BEGIN,
    BOOKMARK_FILTERS_SUCCESS,
    BOOKMARK_FILTERS_FAILURE,
    CLEAR_BOOKMARK_FILTERS,

    EMPLOYEE_SUPERVISOR_SUCCESS,
    EMPLOYEE_SUPERVISOR_BEGIN,
    EMPLOYEE_SUPERVISOR_FAILURE,
    CLEAR_EMPLOYEE_SUPERVISOR,

    BOOKMARKCOURSE_FILTERS_BEGIN,
    BOOKMARKCOURSE_FILTERS_SUCCESS,
    BOOKMARKCOURSE_FILTERS_FAILURE,
    CLEAR_BOOKMARKCOURSE_FILTERS,

} from 'app/actions/BookmarkActions';

const initialState = {
    bookmark: [],
    bookmarkPreview: {},
    bookmarkFilters: {},
    employeeSupervisor: [],
    technicalRepresentative: [],
    TotalRows: 0,
    isLoading: false,
    error: ''
};

export default function BookmarkReducer(state = initialState, action) {
    switch (action.type) {
        case BOOKMARK_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case BOOKMARK_SUCCESS:
            let bookmark = action.payload.data.Data;
            let TotalRows = action.payload.data.TotalRows;
            return {
                ...state,
                bookmark,
                TotalRows,
                isLoading: false,
            }
        case CLEAR_BOOKMARK:
            return {
                ...state,
                bookmark: [],
                isLoading: false,
            }
        case BOOKMARK_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case BOOKMARK_PREVIEW_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case BOOKMARK_PREVIEW_SUCCESS:
            let bookmarkPreview = action.payload.data;
            return {
                ...state,
                bookmarkPreview,
                //TotalRows,
                isLoading: false,
            }
        case CLEAR_BOOKMARK_PREVIEW:
            return {
                ...state,
                bookmarkPreview: [],
                isLoading: false,
            }
        case BOOKMARK_PREVIEW_FAILURE:
            return {
                ...state,
                error: 'Ocurrió un error, intente más tarde.',
                isLoading: false
            }
        case BOOKMARK_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case BOOKMARK_FILTERS_SUCCESS:
            let bookmarkFilters = action.payload.data;
            return {
                ...state,
                bookmarkFilters,
                isLoading: false,
            }
        case CLEAR_BOOKMARK_FILTERS:
            return {
                ...state,
                bookmarkFilters: {},
                isLoading: false,
            }
        case BOOKMARK_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case BOOKMARKCOURSE_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case BOOKMARKCOURSE_FILTERS_SUCCESS:
            let bookmarkCourseFilters = action.payload.data;
            return {
                ...state,
                bookmarkCourseFilters,
                isLoading: false,
            }
        case CLEAR_BOOKMARKCOURSE_FILTERS:
            return {
                ...state,
                bookmarkCourseFilters: {},
                isLoading: false,
            }
        case BOOKMARKCOURSE_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case EMPLOYEE_SUPERVISOR_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case EMPLOYEE_SUPERVISOR_SUCCESS:
            let employeeSupervisor = action.payload.data.Data;
            return {
                ...state,
                employeeSupervisor,
                isLoading: false,
            }
        case CLEAR_EMPLOYEE_SUPERVISOR:
            return {
                ...state,
                employeeSupervisor: {},
                isLoading: false,
            }
        case EMPLOYEE_SUPERVISOR_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

//BOOKMARKS
export const getBookmark = state => {
    return state.bookmark.map(i => Object.assign(i, { TotalRows: state.TotalRows }))
}
export const getIsLoadingBookmark = state => {
    return state.isLoading;
}
//BOOKMARKS_PREVIEW
export const getBookmarkPreview = state => {
    return state.bookmarkPreview;
}
export const getIsLoadingBookmarkPreview = state => {
    return state.isLoading;
}

//BOOKMARK_FILTERS
export const getBookmarkFilters = state => {
    return state.bookmarkFilters
}
export const getIsLoadingBookmarkFilters = state => {
    return state.isLoading;
};
export const getBookmarkCourseFilters = state => {
    return state.bookmarkCourseFilters
}

//EMPLOYEE_SUPERVISOR
export const getEmployeeSupervisor = state => {
    return state.employeeSupervisor;
}
export const getIsLoadingEmployeeSupervisor = state => {
    return state.isLoading;
}

